import {openLeadModal, setUseAdditionalFormField} from "../../application/state/main_lead_slice";
import {openLoginDrawer, openSignupDrawer} from "../../semantic_search/state/semantic_search_auth_slice";
import {useAppDispatch} from "../../store/hooks";
import {startRegistrationFlow} from "../state/registration_flow_slice";
import {trackAmplitudeAuthEvent} from "../tracking/track_amplitude_auth_event";
import {RegistrationFlowControlAction} from "../types/RegistrationFlowControlAction";
import {useRedirectedAuth} from "./use_redirected_auth";

export const useRunRegistrationFlowControlAction = () => {
    const dispatch = useAppDispatch();
    const {onRedirectedLogin} = useRedirectedAuth();

    return (controlAction: RegistrationFlowControlAction) => {
        if (controlAction.amplitudeAuthClick) {
            trackAmplitudeAuthEvent(controlAction.amplitudeAuthClick.event, controlAction.amplitudeAuthClick.params);
        }

        switch (controlAction.type) {
            case "lead_modal":
                if (controlAction.payload.useAdditionalFormField) {
                    dispatch(setUseAdditionalFormField(controlAction.payload.useAdditionalFormField));
                }

                dispatch(openLeadModal(controlAction.payload));
                return;
            case "km_login":
                void onRedirectedLogin(controlAction.redirectQuery);
                return;
            case "registration_flow":
                dispatch(startRegistrationFlow(controlAction.flow));
                return;
            case "semantic_search_auth_drawer":
                dispatch(controlAction.drawer === "login" ? openLoginDrawer() : openSignupDrawer());
                return;
            case "none":
                return;
        }
    };
};
import {openLeadModal, setUseAdditionalFormField} from "../../application/state/main_lead_slice";
import {openLoginDrawer, openSignupDrawer} from "../../semantic_search/state/semantic_search_auth_slice";
import {useAppDispatch} from "../../store/hooks";
import {startRegistrationFlow} from "../state/registration_flow_slice";
import {trackAmplitudeAuthEvent} from "../tracking/track_amplitude_auth_event";
import {RegistrationFlowControlAction} from "../types/RegistrationFlowControlAction";
import {useRedirectedAuth} from "./use_redirected_auth";

export const useRunRegistrationFlowControlAction = () => {
    const dispatch = useAppDispatch();
    const {onRedirectedLogin} = useRedirectedAuth();

    return (controlAction: RegistrationFlowControlAction) => {
        if (controlAction.amplitudeAuthClick) {
            trackAmplitudeAuthEvent(controlAction.amplitudeAuthClick.event, controlAction.amplitudeAuthClick.params);
        }

        switch (controlAction.type) {
            case "lead_modal":
                if (controlAction.payload.useAdditionalFormField) {
                    dispatch(setUseAdditionalFormField(controlAction.payload.useAdditionalFormField));
                }

                dispatch(openLeadModal(controlAction.payload));
                return;
            case "km_login":
                void onRedirectedLogin(controlAction.redirectQuery);
                return;
            case "registration_flow":
                dispatch(startRegistrationFlow(controlAction.flow));
                return;
            case "semantic_search_auth_drawer":
                dispatch(controlAction.drawer === "login" ? openLoginDrawer() : openSignupDrawer());
                return;
            case "none":
                return;
        }
    };
};
